import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

const OperatorsCount = () => {
    const [operatorCount, setOperatorCount] = useState(0);

    useEffect(() => {
        const fetchOperators = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, 'transactions'));
                const operatorSet = new Set();

                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    if (data.operator) {
                        operatorSet.add(data.operator);
                    }
                });

                setOperatorCount(operatorSet.size);
            } catch (error) {
                console.error('Error fetching unique operator count:', error);
            }
        };

        fetchOperators();
    }, []);

    return <span>{operatorCount}</span>;
};

export default OperatorsCount;
